<app-dialog
  [title]="data?.title ? data?.title : 'Edit Note'"
  (close)="close()"
  (action)="action($event)"
  [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    { text: 'Save', isDisabled: !this.notes.value || spin, spin: spin }
  ]"
>
  <div class="notes_part mt-3">
    <div class="input-container">
      <label class="input-container_label">Notes:</label>
      <textarea
        class="input-container_input"
        [formControl]="notes"
        rows="3"
        maxlength="1000"
      ></textarea>
    </div>
  </div>
</app-dialog>
